import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'
import { createTableSettingSelector } from '../../../form/state/table-state-helper'
import { selectHasRole } from '../../../security/state/auth/selector'
import { createTableSelector } from '../../../table/state/selector'
import { TABLE_ALL_OPEN_TASK } from './type'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectTaskList = (state) => {
    return selectOwnState(state).taskList
}

export const selectUserTaskList = (state) => {
    const taskList = selectTaskList(state)

    return taskList.filter((task) => {
        return selectHasRole(state, task.role)
    })
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectTable = createTableSelector(selectOwnState, TABLE_ALL_OPEN_TASK)

export const selectTableSetting = createTableSettingSelector(selectOwnState)

export const selectAllOpenTaskTableSetting = createTableSettingSelector(selectOwnState, 'allOpenTaskTableSetting')



// WEBPACK FOOTER //
// ./src/modules/process/state/task-list/selector.js